import { render, staticRenderFns } from "./EditProductCodePatch.vue?vue&type=template&id=44dd0a0c&scoped=true&"
import script from "./EditProductCodePatch.vue?vue&type=script&lang=js&"
export * from "./EditProductCodePatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44dd0a0c",
  null
  
)

export default component.exports